import React from 'react';

import './StepNavigation.scss';
import Step from "../Step/Step";

export default function StepNavigation(props) {
    const completedSteps = props.currentStep - 1;

    return (
        <div className={'stepWrapper'}>
            {
                props.labelArray.map((item, index) =>
                    <Step
                        key={index}
                        index={index}
                        label={item}
                        length={props.labelArray.length}
                        updateStep={props.updateStep}
                        selected={props.currentStep === index + 1}
                        completedSteps={completedSteps}
                    ></Step>)
            }
        </div>
    )
}

